export function setupUnlockForm() {
    const form = document.getElementById("unlockForm");
    
    if (!form) {
        return;
    }
    
    const submitButton = document.getElementById("submit");
    const action = form.getAttribute("action");
    const codeInput = document.getElementById("Code");
    
    if (codeInput) {
        codeInput.addEventListener("keyup", (e) => {
            if (e.target.value.length === 0) {
                submitButton.setAttribute("disabled", "disabled");
            }
            else {
                submitButton.removeAttribute("disabled");
            }
        });
    }
    
    if (form) {
        form.addEventListener("submit", async (e) => {
            e.preventDefault();
            
            await handleUnlockSubmit();
        })
    }
    
    async function handleUnlockSubmit() {
        const codeFeedback = document.getElementById("codeFeedback");
        codeFeedback.style.display = 'none';
        codeInput.classList.remove("is-invalid");
        
        submitButton.innerHTML = `Verifierar...`;

        const body = new URLSearchParams(new FormData(form)).toString();
        codeInput.setAttribute('disabled', 'disabled');
        
        const response = await fetch(action, {
            method: "POST",
            body,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                "X-Requested-With": "XMLHttpRequest"
            }
        });

        if (response.ok) {
            const json = await response.json();
            const { codeWasValidated, errorMessage } = json;
            
            if (!codeWasValidated) {
                codeInput.classList.remove("is-valid");
                codeInput.classList.remove('was-validated');
                form.classList.remove('was-validated');
                codeInput.classList.add("is-invalid");
                codeFeedback.style.display = 'block';
                codeFeedback.innerHTML = errorMessage;
                codeInput.removeAttribute('disabled');
            }
            else {
                const { redirectUrl } = json;
                form.style.display = 'none';
                var messageElement = document.getElementById("code-valid-message");
                messageElement.style.display = 'block';
                messageElement.classList.remove('d-none');
                window.location.href = redirectUrl;
            } 
        }
        else {
            const errorResponse = await response.json();
            const {errorMessage} = errorResponse;
            
            switch (errorMessage) {
                case "CODE_NOT_VALID":
                    alert('Den koden är inte giltig.')
            }
        }
    }
}